import { buildModelManager } from "../builder.js";
const DefaultSpinwheelResultSelection = {
  __typename: true,
  id: true,
  campaignId: true,
  claimed: true,
  claimedAt: true,
  createdAt: true,
  discountCode: true,
  email: true,
  ipAddress: true,
  metadata: true,
  pageUrl: true,
  prizeLabel: true,
  prizeType: true,
  prizeValue: true,
  segmentIndex: true,
  shopId: true,
  spinDurationMs: true,
  spunAt: true,
  updatedAt: true,
  userAgent: true,
  visitorId: true
};
const modelApiIdentifier = "spinwheel_result";
const pluralModelApiIdentifier = "spinwheel_results";
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSpinwheelResultSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultSpinwheelResultSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSpinwheelResultSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSpinwheelResultSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultSpinwheelResultSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSpinwheelResultSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultSpinwheelResultSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createSpinwheelResult",
    operationReturnType: "CreateSpinwheelResult",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      spinwheel_result: { required: false, type: "CreateSpinwheelResultInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultSpinwheelResultSelection
  },
  {
    type: "action",
    operationName: "bulkCreateSpinwheelResults",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateSpinwheelResultsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultSpinwheelResultSelection
  }
];
const SpinwheelResultManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultSpinwheelResultSelection,
  operations
);
export {
  DefaultSpinwheelResultSelection,
  SpinwheelResultManager
};
//# sourceMappingURL=SpinwheelResult.js.map
